import type { QueryClient, QueryKey } from "@tanstack/react-query";

/**
 * Put what the server answered to a write into the cache, whole. A read on its way was
 * sent before the write landed, so it is cancelled rather than let answer after it with
 * the data as it was.
 */
export async function takeServed(
  qc: QueryClient,
  key: QueryKey,
  served: unknown,
): Promise<void> {
  await qc.cancelQueries({ queryKey: key });
  qc.setQueryData(key, served);
}
